enum ProjectStatus {
    INVISIBLE = "INVISIBLE", // Under preparation - not visible on board
    PREPARED = "PREPARED",  // Prepared but not actually stated
    ACTIVE = "ACTIVE",      // Actualy started (there is a onhire/notice of arrival)
    ENDED = "ENDED",        // Actually ended (offhire), but not fully closed (not fully invoiced)
    COMPLETED = "COMPLETED"  // All activities, also in office completed

  }
  
  export default ProjectStatus;